export var ImageDocumentEnum;
(function (ImageDocumentEnum) {
    ImageDocumentEnum["policy"] = "policy";
    ImageDocumentEnum["license"] = "license";
    ImageDocumentEnum["registration"] = "registration";
    ImageDocumentEnum["vin"] = "vin";
    ImageDocumentEnum["milleage"] = "milleage";
    ImageDocumentEnum["interior"] = "interior";
    ImageDocumentEnum["odometer"] = "odometer";
    ImageDocumentEnum["spareTyre"] = "spareTyre";
    ImageDocumentEnum["ine"] = "ine";
    ImageDocumentEnum["document"] = "document_";
    ImageDocumentEnum["plate"] = "plate";
    ImageDocumentEnum["rear_plate"] = "rear_plate";
    ImageDocumentEnum["front_plate"] = "front_plate";
    ImageDocumentEnum["signature"] = "signature";
    ImageDocumentEnum["screenshot"] = "screenshot_";
})(ImageDocumentEnum || (ImageDocumentEnum = {}));
